import { configureStore } from "@reduxjs/toolkit";
import booksReduser from "./slices/booksSlice";
import filterReducer from "./slices/filterSlice";
import errorSlice from "./slices/errorSlice";

const store = configureStore({
   reducer: {
      books: booksReduser,
      filter: filterReducer,
      errot: errorSlice,
   },
});

export default store;
